/**
 * Lumière — core storefront interactions
 * Cart AJAX API (add/update/get), drawer, quick-add, variant selection,
 * sticky add-to-cart, product gallery, accordions.
 * No frameworks — Shopify AJAX Cart API + fetch.
 */
(function () {
  "use strict";

  var routes = {
    cartAdd: "/cart/add.js",
    cartChange: "/cart/change.js",
    cartClear: "/cart/clear.js",
    cartGet: "/cart.js",
  };

  var Offer = {
    FREE_EVERY: 3,
    unitPrices: function (cart) {
      var prices = [];
      cart.items.forEach(function (item) {
        for (var i = 0; i < item.quantity; i++) prices.push(item.final_price);
      });
      return prices.sort(function (a, b) { return a - b; });
    },
    discount: function (cart) {
      var prices = Offer.unitPrices(cart);
      var free = Math.floor(prices.length / Offer.FREE_EVERY);
      return prices.slice(0, free).reduce(function (sum, price) { return sum + price; }, 0);
    },
  };

  var Cart = {
    drawer: null,
    overlay: null,
    init: function () {
      this.drawer = document.querySelector("[data-cart-drawer]");
      this.overlay = document.querySelector("[data-cart-overlay]");
      if (!this.drawer) return;
      document.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener("submit", this.handleSubmit.bind(this));
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") Cart.close();
      });
      this.refresh();
    },
    handleClick: function (e) {
      if (e.target.closest("[data-cart-toggle]")) {
        e.preventDefault();
        this.open();
      }
      if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-overlay]")) {
        this.close();
      }
      var qtyBtn = e.target.closest("[data-qty-change]");
      if (qtyBtn) {
        e.preventDefault();
        var line = qtyBtn.dataset.line;
        var delta = parseInt(qtyBtn.dataset.qtyChange, 10);
        var display = document.querySelector('[data-qty-input][data-line="' + line + '"]');
        var current = parseInt(display.textContent.trim(), 10);
        if (!Number.isFinite(current)) return;
        this.updateLine(line, Math.max(0, current + delta));
      }
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (removeBtn) {
        e.preventDefault();
        this.updateLine(removeBtn.dataset.line, 0);
      }
      var quickAdd = e.target.closest("[data-quick-add]");
      if (quickAdd) {
        e.preventDefault();
        this.addItem(quickAdd.dataset.variantId, 1, quickAdd);
      }
    },
    handleSubmit: function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var giftColor = GiftColors.getSelected();
      var properties = giftColor ? { "لون النظارة": giftColor } : null;
      this.addItem(formData.get("id"), formData.get("quantity") || 1, submitBtn, properties);
    },
    addItem: function (variantId, quantity, triggerEl, properties) {
      if (!variantId) return;
      if (triggerEl) {
        triggerEl.dataset.originalText = triggerEl.textContent;
        triggerEl.textContent = triggerEl.dataset.loadingText || "Adding…";
        triggerEl.disabled = true;
      }
      fetch(routes.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties || undefined }),
      })
        .then(function (res) { return res.json(); })
        .then(function () { return Cart.refresh(); })
        .then(function () { Cart.open(); })
        .catch(function (err) { console.error("[cart] add failed", err); })
        .finally(function () {
          if (triggerEl) {
            triggerEl.textContent = triggerEl.dataset.originalText;
            triggerEl.disabled = false;
          }
        });
    },
    updateLine: function (line, quantity) {
      fetch(routes.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function () { return Cart.refresh(); })
        .catch(function (err) { console.error("[cart] update failed", err); });
    },
    refresh: function () {
      return fetch(routes.cartGet)
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          Cart.render(cart);
          Cart.updateCount(cart.item_count);
        });
    },
    updateCount: function (count) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },
    render: function (cart) {
      var bodies = document.querySelectorAll("[data-cart-lines]");
      var footers = document.querySelectorAll("[data-cart-footer]");
      if (!bodies.length) return;
      if (cart.item_count === 0) {
        var empty = '<p class="text-muted" data-cart-empty>' + (window.themeStrings.cartEmpty || "Your cart is empty.") + "</p>";
        bodies.forEach(function (body) { body.innerHTML = empty; });
        footers.forEach(function (footer) { footer.hidden = true; });
      } else {
        var html = cart.items
          .map(function (item, i) {
            var variantLine = item.variant_title
              ? '<p class="text-muted">' + item.variant_title + "</p>"
              : "";
            return (
              '<div class="cart-line" data-line="' + (i + 1) + '">' +
              '<img src="' + item.image + '" alt="' + item.product_title + '" width="76" height="96" loading="lazy">' +
              '<div class="cart-line__details">' +
              "<p>" + item.product_title + "</p>" +
              variantLine +
              '<div class="cart-line__qty">' +
              '<button type="button" data-qty-change="-1" data-line="' + (i + 1) + '" aria-label="Decrease quantity">−</button>' +
              '<span data-qty-input data-line="' + (i + 1) + '">' + item.quantity + "</span>" +
              '<button type="button" data-qty-change="1" data-line="' + (i + 1) + '" aria-label="Increase quantity">+</button>' +
              "</div>" +
              '<button type="button" class="cart-line__remove" data-cart-remove data-line="' + (i + 1) + '">إزالة</button>' +
              "</div>" +
              '<div class="cart-line__price">' + Cart.formatMoney(item.final_line_price) + "</div>" +
              "</div>"
            );
          })
          .join("");
        bodies.forEach(function (body) { body.innerHTML = html; });
        footers.forEach(function (footer) { footer.hidden = false; });
      }
      Cart.updateTotals(cart);
      Cart.updateFreeShipping(cart.total_price);
    },
    updateTotals: function (cart) {
      var discount = 0;
      document.querySelectorAll("[data-cart-subtotal]").forEach(function (el) {
        el.textContent = Cart.formatMoney(cart.total_price);
      });
      document.querySelectorAll("[data-cart-discount]").forEach(function (el) {
        el.textContent = "−" + Cart.formatMoney(discount);
      });
      document.querySelectorAll("[data-cart-discount-row]").forEach(function (el) {
        el.hidden = discount === 0;
      });
      document.querySelectorAll("[data-cart-total]").forEach(function (el) {
        el.textContent = Cart.formatMoney(cart.total_price - discount);
      });
    },
    updateFreeShipping: function (totalCents) {
      var bar = document.querySelector("[data-free-shipping-bar]");
      if (!bar) return;
      var threshold = parseInt(bar.dataset.threshold, 10) * 100;
      var remaining = Math.max(0, threshold - totalCents);
      var pct = Math.min(100, (totalCents / threshold) * 100);
      var fill = bar.querySelector(".free-shipping-bar__fill");
      var label = bar.querySelector("[data-free-shipping-label]");
      if (fill) fill.style.width = pct + "%";
      if (label) {
        label.textContent =
          remaining === 0
            ? window.themeStrings.freeShippingUnlocked || "You've unlocked free shipping!"
            : (window.themeStrings.freeShippingProgress || "Add {amount} more for free shipping").replace(
                "{amount}",
                Cart.formatMoney(remaining)
              );
      }
    },
    formatMoney: function (cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
        style: "currency",
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "USD",
      });
    },
    open: function () {
      this.drawer.classList.add("is-open");
      this.overlay.classList.add("is-open");
      this.drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      this.overlay.classList.remove("is-open");
      this.drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    },
  };

  var VariantPicker = {
    init: function () {
      document.querySelectorAll("[data-variant-picker]").forEach(function (picker) {
        picker.addEventListener("click", function (e) {
          var btn = e.target.closest(".variant-swatch");
          if (!btn || btn.disabled) return;
          picker.querySelectorAll(".variant-swatch").forEach(function (b) {
            b.classList.remove("is-selected");
          });
          btn.classList.add("is-selected");
          VariantPicker.updateSelection(picker);
        });
        var preselected = picker.querySelector(".variant-swatch.is-selected");
        if (preselected) VariantPicker.applySwatchMedia(preselected);
      });
    },
    applySwatchMedia: function (btn) {
      var mediaId = btn.dataset.mediaId;
      if (!mediaId) return;
      var gallery = document.querySelector("[data-gallery]");
      var matchingThumb = gallery && gallery.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
      if (matchingThumb) Gallery.selectThumb(gallery, matchingThumb);
    },
    updateSelection: function (picker) {
      var form = picker.closest("[data-product-form]");
      if (!form) return;
      var selectedOptions = [];
      form.querySelectorAll("[data-variant-picker]").forEach(function (p) {
        var selected = p.querySelector(".variant-swatch.is-selected");
        if (selected) selectedOptions.push(selected.dataset.value);
      });
      var variants = JSON.parse(form.dataset.variants || "[]");
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector("[data-product-price]");
      var atcBtn = form.querySelector('[type="submit"]');
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = Cart.formatMoney(match.price);
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available
            ? atcBtn.dataset.addText || "Add to Cart"
            : atcBtn.dataset.soldOutText || "Sold Out";
        }
        var quickOrderForm = document.querySelector("[data-quick-order]");
        if (quickOrderForm) quickOrderForm.dataset.variantId = match.id;
      }
      var selectedBtn = picker.querySelector(".variant-swatch.is-selected");
      if (selectedBtn) VariantPicker.applySwatchMedia(selectedBtn);
    },
  };

  var GiftColors = {
    init: function () {
      document.querySelectorAll("[data-gift-colors]").forEach(function (picker) {
        picker.addEventListener("click", function (e) {
          var btn = e.target.closest(".gift-swatch");
          if (!btn) return;
          picker.querySelectorAll(".gift-swatch").forEach(function (b) {
            b.classList.remove("is-selected");
          });
          btn.classList.add("is-selected");
        });
      });
    },
    getSelected: function () {
      var selected = document.querySelector("[data-gift-colors] .gift-swatch.is-selected");
      return selected ? selected.dataset.value : null;
    },
  };

  var Gallery = {
    init: function () {
      document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
        var main = gallery.querySelector("[data-gallery-main]");
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
          thumb.addEventListener("click", function () {
            Gallery.selectThumb(gallery, thumb);
          });
        });
        if (main) {
          main.addEventListener("click", function (event) {
            if (event.target.closest("video, iframe, model-viewer, button")) return;
            main.classList.toggle("is-zoomed");
          });
        }
      });
    },
    selectThumb: function (gallery, thumb) {
      gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
        t.classList.remove("is-active");
      });
      thumb.classList.add("is-active");
      Gallery.setMainMedia(gallery, thumb);
    },
    setMainMedia: function (gallery, thumb) {
      var main = gallery.querySelector("[data-gallery-main]");
      if (!main) return;
      var template = thumb.querySelector("[data-gallery-media-template]");
      if (!template) return;
      var existingVideo = main.querySelector("video");
      if (existingVideo) existingVideo.pause();
      main.classList.remove("is-zoomed");
      main.innerHTML = template.innerHTML;
      var nextVideo = main.querySelector("video");
      if (nextVideo) nextVideo.play().catch(function () {});
    },
  };

  var LazyVideo = {
    init: function () {
      var videos = document.querySelectorAll("[data-lazy-video]");
      if (!videos.length) return;
      if (!("IntersectionObserver" in window)) {
        videos.forEach(LazyVideo.load);
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              if (!video.dataset.loaded) LazyVideo.load(video);
              video.play().catch(function () {});
            } else if (video.dataset.loaded) {
              video.pause();
            }
          });
        },
        { rootMargin: "200px 0px" }
      );
      videos.forEach(function (video) { observer.observe(video); });
    },
    load: function (video) {
      var src = video.dataset.src;
      if (!src) return;
      var source = document.createElement("source");
      source.src = src;
      source.type = "video/mp4";
      video.appendChild(source);
      video.load();
      video.dataset.loaded = "true";
    },
  };

  var StickyATC = {
    init: function () {
      var sticky = document.querySelector("[data-sticky-atc]");
      var trigger = document.querySelector("[data-atc-trigger]");
      if (!sticky || !trigger) return;
      var observer = new IntersectionObserver(
        function (entries) { sticky.classList.toggle("is-visible", !entries[0].isIntersecting); },
        { threshold: 0 }
      );
      observer.observe(trigger);
    },
  };

  var QUICK_ORDER_ENDPOINT = "https://orel-checkout.dadasnapwahd.workers.dev";

  var Tracking = {
    FBCLID_KEY: "orel_fbclid",
    TTCLID_KEY: "orel_ttclid",
    ATTRIBUTION_KEY: "orel_attribution",
    TIKTOK_PIXEL_ID: "D9QN5UJC77U7K82NO5UG",
    init: function () {
      try {
        var query = new URLSearchParams(window.location.search);
        var fbclid = query.get("fbclid");
        if (fbclid) window.sessionStorage.setItem(this.FBCLID_KEY, fbclid);
        var ttclid = query.get("ttclid");
        if (ttclid) window.sessionStorage.setItem(this.TTCLID_KEY, ttclid);

        var attribution = {};
        ["utm_source", "utm_medium", "utm_campaign", "utm_id", "tt_campaignid"].forEach(function (key) {
          var value = query.get(key);
          if (value) attribution[key] = value;
        });
        if (Object.keys(attribution).length) {
          window.sessionStorage.setItem(Tracking.ATTRIBUTION_KEY, JSON.stringify(attribution));
        }
      } catch (e) {}
      this.initTikTokPixel();
    },
    initTikTokPixel: function () {
      var pixelId = this.TIKTOK_PIXEL_ID;
      if (window.ttq && typeof window.ttq.track === "function") {
        if (typeof window.ttq.load === "function" && !(window.ttq._i && window.ttq._i[pixelId])) {
          window.ttq.load(pixelId);
        }
        return;
      }

      (function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = (w[t] = w[t] || []);
        ttq.methods = [
          "page", "track", "identify", "instances", "debug", "on", "off", "once", "ready",
          "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"
        ];
        ttq.setAndDefer = function (target, method) {
          target[method] = function () {
            target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function (id) {
          var instance = (ttq._i && ttq._i[id]) || [];
          for (var j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(instance, ttq.methods[j]);
          return instance;
        };
        ttq.load = function (id, options) {
          var src = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._i = ttq._i || {};
          ttq._i[id] = ttq._i[id] || [];
          ttq._i[id]._u = src;
          ttq._t = ttq._t || {};
          ttq._t[id] = +new Date();
          ttq._o = ttq._o || {};
          ttq._o[id] = options || {};
          var script = d.createElement("script");
          script.type = "text/javascript";
          script.async = true;
          script.src = src + "?sdkid=" + id + "&lib=" + t;
          var firstScript = d.getElementsByTagName("script")[0];
          firstScript.parentNode.insertBefore(script, firstScript);
        };
        ttq.load(pixelId);
      })(window, document, "ttq");
    },
    readCookie: function (name) {
      var parts = document.cookie.split("; ");
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf(name + "=") === 0) return parts[i].slice(name.length + 1);
      }
      return undefined;
    },
    params: function () {
      var fbc = this.readCookie("_fbc");
      var ttclid = null;
      var attribution = {};
      if (!fbc) {
        var fbclid = null;
        try {
          fbclid =
            new URLSearchParams(window.location.search).get("fbclid") ||
            window.sessionStorage.getItem(this.FBCLID_KEY);
        } catch (e) {}
        if (fbclid) fbc = "fb.1." + Date.now() + "." + fbclid;
      }
      try {
        ttclid =
          new URLSearchParams(window.location.search).get("ttclid") ||
          window.sessionStorage.getItem(this.TTCLID_KEY);
        attribution = JSON.parse(window.sessionStorage.getItem(this.ATTRIBUTION_KEY) || "{}");
      } catch (e) {}
      return {
        fbp: this.readCookie("_fbp"),
        fbc: fbc,
        ttclid: ttclid,
        ttp: this.readCookie("_ttp"),
        attribution: attribution,
        eventSourceUrl: window.location.href,
      };
    },
    track: function (event, data, eventId) {
      if (typeof window.fbq === "function") {
        if (eventId) {
          window.fbq("track", event, data, { eventID: eventId });
        } else {
          window.fbq("track", event, data);
        }
      }

      this.initTikTokPixel();
      if (window.ttq && typeof window.ttq.track === "function") {
        var ids = (data.content_ids || []).map(String);
        var quantity = Number(data.num_items || 1);
        var perItemValue = ids.length && Number(data.value) ? Number(data.value) / quantity : undefined;
        var tikTokData = {
          content_type: data.content_type || "product",
          contents: ids.map(function (id) {
            var item = { content_id: id, quantity: Math.max(1, Math.round(quantity / Math.max(ids.length, 1))) };
            if (perItemValue) item.price = perItemValue;
            return item;
          }),
          currency: data.currency || "MAD",
          value: Number(data.value || 0),
        };
        if (eventId) {
          window.ttq.track(event, tikTokData, { event_id: eventId });
        } else {
          window.ttq.track(event, tikTokData);
        }
      }
    },
  };

  window.orelTracking = Tracking;

  var QuickOrder = {
    checkoutTracked: false,
    init: function () {
      var form = document.querySelector("[data-quick-order]");
      if (!form) return;
      form.addEventListener("submit", this.handleSubmit.bind(this));
      form.addEventListener("focusin", this.trackCheckoutStart.bind(this), { once: true });
    },
    trackCheckoutStart: function () {
      if (this.checkoutTracked) return;
      this.checkoutTracked = true;
      var form = document.querySelector("[data-quick-order]");
      var variantId = form ? String(form.dataset.variantId).replace(/\D/g, "") : "";
      Tracking.track("InitiateCheckout", {
        content_ids: [variantId],
        content_type: "product",
        currency: "MAD",
        num_items: 1,
      });
    },
    handleSubmit: function (e) {
      e.preventDefault();
      var form = e.target;
      if (form.dataset.submitting === "true") return;
      form.dataset.submitting = "true";
      var submitBtn = form.querySelector('[type="submit"]');
      var variantIdGid = form.dataset.variantId;
      var variantId = String(variantIdGid).replace(/\D/g, "");
      var name = form.querySelector('[name="name"]').value;
      var phone = form.querySelector('[name="phone"]').value;
      var city = form.querySelector('[name="city"]').value;
      var address = form.querySelector('[name="address"]').value;
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.dataset.loadingText || "…";
      this.trackCheckoutStart();
      var fbParams = Tracking.params();
      fetch(QUICK_ORDER_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          variantId: variantId,
          quantity: 1,
          name: name,
          phone: phone,
          city: city,
          address: address,
          glassesColor: GiftColors.getSelected(),
          fbp: fbParams.fbp,
          fbc: fbParams.fbc,
          ttclid: fbParams.ttclid,
          ttp: fbParams.ttp,
          attribution: fbParams.attribution,
          eventSourceUrl: fbParams.eventSourceUrl,
        }),
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok || !result.data.success) {
            throw new Error((result.data && result.data.error) || "order failed");
          }
          Tracking.track(
            "Purchase",
            {
              content_ids: [variantId],
              content_type: "product",
              currency: "MAD",
              num_items: 1,
              order_id: result.data.orderName,
              value: result.data.total,
            },
            "purchase_" + result.data.orderName
          );
          form.innerHTML =
            '<p style="color:var(--color-accent);font-size:1rem;">✔ تم تسجيل الطلب ديالك بنجاح! رقم الطلب: ' +
            result.data.orderName +
            "<br>غادي نتصلو بيك من هاتفك باش نأكدو الطلب.</p>";
        })
        .catch(function (err) {
          console.error("[quick-order] failed", err);
          form.dataset.submitting = "false";
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || "Order Now";
          alert("وقع مشكل، عافاك عاود المحاولة أو تواصل معنا مباشرة.");
        });
    },
  };

  var CartOrder = {
    checkoutTracked: false,
    init: function () {
      if (!document.querySelector("[data-cod-order]")) return;
      document.addEventListener("submit", this.handleSubmit.bind(this));
      document.addEventListener("focusin", this.trackCheckoutStart.bind(this));
    },
    trackCheckoutStart: function (e) {
      if (this.checkoutTracked) return;
      if (e && !e.target.closest("[data-cod-order]")) return;
      this.checkoutTracked = true;
      fetch(routes.cartGet)
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          Tracking.track("InitiateCheckout", {
            content_ids: cart.items.map(function (item) { return String(item.variant_id); }),
            content_type: "product",
            currency: "MAD",
            num_items: cart.item_count,
          });
        })
        .catch(function () {});
    },
    handleSubmit: function (e) {
      var form = e.target.closest("[data-cod-order]");
      if (!form) return;
      e.preventDefault();
      if (form.dataset.submitting === "true") return;
      form.dataset.submitting = "true";
      var submitBtn = form.querySelector('[type="submit"]');
      var field = function (name) { return form.querySelector('[name="' + name + '"]').value.trim(); };
      var fbParams = Tracking.params();
      var payload = {
        name: field("name"),
        phone: field("phone"),
        city: field("city"),
        address: field("address"),
        fbp: fbParams.fbp,
        fbc: fbParams.fbc,
        ttclid: fbParams.ttclid,
        ttp: fbParams.ttp,
        attribution: fbParams.attribution,
        eventSourceUrl: fbParams.eventSourceUrl,
      };
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.dataset.loadingText || "…";
      this.trackCheckoutStart();
      fetch(routes.cartGet)
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart.items.length) throw new Error("cart is empty");
          payload.items = cart.items.map(function (item) {
            return {
              variantId: String(item.variant_id),
              quantity: item.quantity,
              properties: item.properties || null,
            };
          });
          return fetch(QUICK_ORDER_ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
        })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok || !result.data.success) {
            throw new Error((result.data && result.data.error) || "order failed");
          }
          Tracking.track(
            "Purchase",
            {
              content_ids: payload.items.map(function (item) { return item.variantId; }),
              content_type: "product",
              currency: "MAD",
              num_items: payload.items.reduce(function (n, item) { return n + item.quantity; }, 0),
              order_id: result.data.orderName,
              value: result.data.total,
            },
            "purchase_" + result.data.orderName
          );
          return fetch(routes.cartClear, { method: "POST" })
            .catch(function () {})
            .then(function () { return result.data.orderName; });
        })
        .then(function (orderName) {
          Cart.updateCount(0);
          document.querySelectorAll("[data-cart-lines]").forEach(function (body) { body.innerHTML = ""; });
          document.querySelectorAll("[data-cart-footer]").forEach(function (footer) {
            footer.hidden = false;
            footer.innerHTML =
              '<p style="color:var(--color-accent);font-size:1rem;">✔ تم تسجيل الطلب ديالك بنجاح! رقم الطلب: ' +
              orderName +
              "<br>غادي نتصلو بيك فهاتفك باش نأكدو الطلب.</p>";
          });
        })
        .catch(function (err) {
          console.error("[cod-order] failed", err);
          form.dataset.submitting = "false";
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || "تأكيد الطلب";
          alert("وقع مشكل، عافاك عاود المحاولة أو تواصل معنا مباشرة.");
        });
    },
  };

  var MobileMenu = {
    init: function () {
      var toggle = document.querySelector("[data-mobile-menu-toggle]");
      var menu = document.querySelector("[data-mobile-menu]");
      if (!toggle || !menu) return;
      toggle.addEventListener("click", function () {
        var isOpen = menu.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
      menu.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          menu.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
        });
      });
    },
  };

  var Accordion = {
    init: function () {
      document.querySelectorAll(".accordion__trigger").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var item = trigger.closest(".accordion__item");
          var panel = item.querySelector(".accordion__panel");
          var isOpen = item.classList.contains("is-open");
          item.classList.toggle("is-open", !isOpen);
          panel.style.maxHeight = isOpen ? null : panel.scrollHeight + "px";
        });
      });
    },
  };

  window.themeStrings = window.themeStrings || {};

  document.addEventListener("DOMContentLoaded", function () {
    Tracking.init();
    Cart.init();
    VariantPicker.init();
    GiftColors.init();
    Gallery.init();
    LazyVideo.init();
    StickyATC.init();
    QuickOrder.init();
    CartOrder.init();
    MobileMenu.init();
    Accordion.init();
  });
})();


/* Arabic color labels for the Lunettes + G-Shock offer */
(function () {
  function translateOfferColors() {
    if (window.location.pathname !== "/products/offre-lunettes-montre") return;

    var labels = {
      Red: "أحمر",
      Green: "أخضر",
      Black: "أسود",
      Bleu: "أزرق",
      Blue: "أزرق",
      Brown: "بني",
      White: "أبيض"
    };

    document.querySelectorAll(".variant-swatch[data-value]").forEach(function (button) {
      var translated = labels[button.dataset.value];
      if (translated) button.textContent = translated;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", translateOfferColors);
  } else {
    translateOfferColors();
  }
})();


/* Show the chosen watch and glasses colors above their buttons */
(function () {
  function isOfferProduct() {
    return window.location.pathname === "/products/offre-lunettes-montre";
  }

  function updateSelectedColorLabels() {
    if (!isOfferProduct()) return;

    document.querySelectorAll(".variant-picker").forEach(function (picker) {
      var label = picker.querySelector(".variant-picker__label");
      var selected = picker.querySelector(".variant-swatch.is-selected");
      if (!label || !selected) return;

      if (!label.dataset.baseLabel) {
        label.dataset.baseLabel = label.textContent.trim().split(":")[0];
      }

      label.textContent = label.dataset.baseLabel + ": " + selected.textContent.trim();

      picker.querySelectorAll(".variant-swatch").forEach(function (button) {
        button.setAttribute("aria-pressed", button === selected ? "true" : "false");
      });
    });
  }

  function initSelectedColorLabels() {
    if (!isOfferProduct()) return;
    updateSelectedColorLabels();

    document.addEventListener("click", function (event) {
      if (!event.target.closest(".variant-swatch")) return;
      window.requestAnimationFrame(updateSelectedColorLabels);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSelectedColorLabels);
  } else {
    initSelectedColorLabels();
  }
})();


/* Link each watch color directly to its gallery image */
(function () {
  function linkOfferWatchMedia() {
    if (window.location.pathname !== "/products/offre-lunettes-montre") return;

    var mediaByColor = {
      Red: "37809980965013",
      Green: "37809980899477",
      Black: "37809980932245",
      Bleu: "37809980866709"
    };

    Object.keys(mediaByColor).forEach(function (color) {
      var swatch = document.querySelector('.variant-swatch[data-value="' + color + '"]');
      if (swatch) swatch.dataset.mediaId = mediaByColor[color];
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", linkOfferWatchMedia);
  } else {
    linkOfferWatchMedia();
  }
})();


/* Link glasses colors to their available gallery photos */
(function () {
  function linkOfferGlassesMedia() {
    if (window.location.pathname !== "/products/offre-lunettes-montre") return;

    var mediaByColor = {
      "أزرق": "37823089016981",
      "بني": "37822299635861",
      "أبيض": "37823089016981",
      "أسود": "37823121817749"
    };

    Object.keys(mediaByColor).forEach(function (color) {
      var swatch = document.querySelector('.variant-swatch[data-value="' + color + '"]');
      if (swatch) swatch.dataset.mediaId = mediaByColor[color];
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", linkOfferGlassesMedia);
  } else {
    linkOfferGlassesMedia();
  }
})();
